import React, { useEffect } from "react";
import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { Add, Delete } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import {
  fetchAddPesertaSO,
  fetchDeletePesertaSO,
  fetchListPesertaSO,
  fetchResetPesertaSO,
} from "state/stockopnameactions";

const PesertaSO = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { list_karyawan_so, list_peserta_so } = useSelector(
    (state) => state.so
  );
  const { status, message } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(fetchListPesertaSO());
  }, []);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListPesertaSO());
  };

  const HandleAddPeserta = (id_karyawan) => {
    const reqData = {
      id_karyawan,
    };
    dispatch(fetchAddPesertaSO(reqData));
  };

  const handleDelete = (id_karyawan) => {
    dispatch(fetchDeletePesertaSO(id_karyawan));
  };
  const handleReset = () => {
    dispatch(fetchResetPesertaSO());
  };

  const columnsKaryawan = [
    {
      name: "id_karyawan",
      label: "ID Karyawan",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Karyawan",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <>
              <IconButton
                color="info"
                onClick={() => {
                  HandleAddPeserta(id);
                }}
              >
                <Add />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const columnsPeserta = [
    {
      name: "id_karyawan",
      label: "ID Karyawan",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Karyawan",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <>
              <IconButton
                color="error"
                onClick={() => {
                  handleDelete(id);
                }}
              >
                <Delete />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    fixedHeader: false,
    fixedSelectColumn: false,
    print: false,
    download: false,
    viewColumns: false,
    filter: false,
    rowsPerPage: 5,
    rowsPerPageOptions: [],
    responsive: "standard",
  };
  const optionspeserta = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    print: false,
    download: false,
    viewColumns: false,
    filter: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 20, 50],
    responsive: "standard",
  };

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Peserta SO" subtitle="Daftar peserta stockopname" />
      <Box
        mt="20px"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={
            <Typography
              variant="h4"
              fontStyle="normal"
              fontWeight={"bold"}
              sx={{ color: theme.palette.secondary.light }}
            >
              Pilih Karyawan
            </Typography>
          }
          data={list_karyawan_so}
          columns={columnsKaryawan}
          options={options}
        />
      </Box>
      <Box
        mt="20px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography
                variant="h4"
                fontStyle="normal"
                fontWeight={"bold"}
                sx={{ color: theme.palette.secondary.light }}
              >
                Peserta SO
              </Typography>
              <Button
                sx={{
                  backgroundColor: theme.palette.secondary.light,
                  color: theme.palette.background.alt,
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "10px 20px",
                  "&:hover": {
                    backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
                  },
                  marginLeft: "8px",
                }}
                onClick={() => handleReset()}
                startIcon={<Delete />}
              >
                Reset Peserta
              </Button>
            </div>
          }
          data={list_peserta_so}
          columns={columnsPeserta}
          options={optionspeserta}
        />
      </Box>
      <FloatingAlert
        open={message.length > 0}
        onClose={handleCloseSnackbar}
        message={message}
        severity={status === "failed" ? "error" : status}
      />
    </Box>
  );
};

export default PesertaSO;
